"use client";
import createClient from "openapi-fetch";
import { paths } from "@/api/schema"; // (generated from openapi-typescript)
import { toast } from "sonner";

export const {
  GET: get,
  POST: post,
  PUT: put,
  PATCH: patch,
  DELETE: del,
} = createClient<paths>({
  baseUrl: process.env.BASE_API_URL,
  headers: {
    Authorization:
      "Bearer " + (typeof window != "undefined" ? getAccessToken() : ""),
  },
});

export async function errorHandler(error: any) {
  toast("An error occured : ", { description: error?.message });
  if (error?.statusCode === 401 && error?.message === "Unauthorized") {
    window.location.href = "/dashboard/auth/login";
  }
  return error;
}

function getAccessToken() {
  if (sessionStorage.getItem("terminal-impersonation") === "true") {
    return sessionStorage.getItem("terminal-access-token");
  }
  if (sessionStorage.getItem("organizer-impersonation") === "true") {
    return sessionStorage.getItem("organizer-access-token");
  }
  if (!!sessionStorage.getItem("organizer-access-token")) {
    return sessionStorage.getItem("organizer-access-token");
  }
  return localStorage.getItem("dashboard-access-token");
}
